// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { useHistory } from 'react-router';
import { Row, Col } from 'antd/lib/grid';
import Button from 'antd/lib/button';
import { ArrowLeftOutlined } from '@ant-design/icons';
import dimensions from 'utils/dimensions';

interface Props {
    task: any;
    runId: number;
}

export default function TopBarComponent({ task, runId }: Props): JSX.Element {
    const history = useHistory();

    return (
        <Row className='cvat-run-task-page-top-bar' justify='center' align='middle'>
            <Col {...dimensions}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Button
                        type='link'
                        icon={<ArrowLeftOutlined />}
                        onClick={() => history.push(`/labeling-runs/${runId}`)}
                    />
                    <span style={{ fontSize: 20, fontWeight: 600 }}>{`Task #${task.id}`}</span>
                </div>
            </Col>
        </Row>
    );
}
